<ul ngbNav
    #nav="ngbNav"
    class="nav-tabs"
    [destroyOnHide]="false"
    [animation]="false">
  <li ngbNavItem>
    <a ngbNavLink (click)="onTabChange('projects')">Projects</a>
    <ng-template ngbNavContent>
      <ngx-datatable class="similarity-table material striped m-1"
                     [style.overflow-y]="'visible'"
                     [style.height.vh]="50"
                     [rowHeight]="'auto'"
                     [columnMode]="ColumnMode.standard"
                     [footerHeight]="0"
                     [rows]="projects">
        <ngx-datatable-column name="Project code" prop="code" [width]="120">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <a [href]="buildUrlFilteringByProjectCode(value)" target="_blank">{{value}}</a>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Title" prop="title" [width]="150"></ngx-datatable-column>
        <ngx-datatable-column name="Abstract" prop="proposalAbstract" [width]="400"></ngx-datatable-column>
      </ngx-datatable>
    </ng-template>
  </li>
  <li ngbNavItem *ngIf="publications?.length" (click)="onTabChange('publications')">
    <a ngbNavLink>Publications</a>
    <ng-template ngbNavContent>
      <ngx-datatable class="similarity-table material striped m-1"
                     [style.overflow-y]="'visible'"
                     [style.height.vh]="50"
                     [rowHeight]="'auto'"
                     [columnMode]="ColumnMode.standard"
                     [footerHeight]="0"
                     [rows]="publications">
        <ngx-datatable-column name="BibCode" prop="bibCode" [width]="170">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <a publicationLink [bibCode]="value"></a>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Title" prop="title" [width]="150"></ngx-datatable-column>
        <ngx-datatable-column name="Abstract" prop="bibAbstract" [width]="400"></ngx-datatable-column>
      </ngx-datatable>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>
